import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { getMediaThumbnailEditingEnabled } from '../../../redux/modules/auth';
import { useMediaTableContext } from '../../../hooks';

import { VpButton, VpHoverInfo } from '../../components';

import VpMediaInfoMenu from '../../widgets/VpMediaTable/VpMediaInfoMenu';
import VpAttachmentInfoMenu from '../../widgets/VpMediaTable/VpAttachmentInfoMenu';
import VpMediaInfoPreview from './VpMediaInfoPreview';
import VpMediaInfoDetails from './VpMediaInfoDetails';
import VpConditionalUpgradeWrapper from '../../components/VpConditionalUpgradeWrapper/VpConditionalUpgradeWrapper';

const boxStyles = {
  flex: 1,
  padding: '25px'
};
const stackStyles = {
  height: '100%'
};
const buttonStyles = {
  width: 60
};

const VpMediaInfo = ({ media, customThumbnailEnabled }) => {
  const isVideo = !!media?.mediaId;
  const mediaId = media?.mediaId || media?.attachmentId;
  const [isShowingDetails, setIsShowingDetails] = useState(false);

  const { setUpdatingThumbnail } = useMediaTableContext();

  const handleClick = (value) => {
    setIsShowingDetails(value);
  };

  const calculateProps = (compareValue) =>
    compareValue === isShowingDetails
      ? {
          color: 'info',
          variant: 'contained'
        }
      : {
          color: 'neutral'
        };

  return (
    <Box sx={boxStyles}>
      <Stack gap={5} sx={stackStyles}>
        <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between">
          <Stack direction="row" gap="5px">
            <VpButton
              onClick={() => handleClick(false)}
              sx={buttonStyles}
              {...calculateProps(false)}
            >
              Preview
            </VpButton>
            <VpButton onClick={() => handleClick(true)} sx={buttonStyles} {...calculateProps(true)}>
              Details
            </VpButton>
          </Stack>
          <Stack direction="row" gap="5px">
            {isVideo && (
              <VpConditionalUpgradeWrapper condition={!customThumbnailEnabled}>
                {({ isDisabled }) => (
                  <Stack direction="row" alignItems="center" gap="5px" justifyContent="start">
                    <VpButton onClick={() => setUpdatingThumbnail(mediaId)} disabled={isDisabled}>
                      Customize Thumbnail
                    </VpButton>
                    <VpHoverInfo
                      icon={isDisabled ? 'Lock' : 'HelpCircle'}
                      iconProps={{ size: '16px', color: 'vpColors.grey' }}
                      label={
                        isDisabled
                          ? ''
                          : 'Changing the thumbnail will modify how your videos appear on the Plugins you have set up'
                      }
                    />
                  </Stack>
                )}
              </VpConditionalUpgradeWrapper>
            )}
            {isVideo ? <VpMediaInfoMenu media={media} /> : <VpAttachmentInfoMenu media={media} />}
          </Stack>
        </Stack>
        {isShowingDetails ? (
          <VpMediaInfoDetails key={mediaId} media={media} />
        ) : (
          <VpMediaInfoPreview key={mediaId} media={media} />
        )}
      </Stack>
    </Box>
  );
};

VpMediaInfo.propTypes = {
  media: PropTypes.shape({
    mediaId: PropTypes.string,
    attachmentId: PropTypes.string
  }),
  customThumbnailEnabled: PropTypes.bool
};

const mapStateToProps = (state) => ({
  customThumbnailEnabled: getMediaThumbnailEditingEnabled(state)
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VpMediaInfo);



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfo.jsx